export default {
  success: {
    edit: '{title} edited successfully'
  },
  startShipping: {
    title: 'Start shipping',
    message: 'Are you sure about starting this load?'
  },
  acceptOffer: {
    title: 'Accept offer',
    message: 'Are you sure about accepting this offer?',
    success: 'Offer accepted successfully'
  },
  cancelOrder: {
    title: 'Cancel Order',
    message: 'Are you sure about canceling this order?',
    success: 'Order canceled successfully'
  },
  reachOrigin: {
    message: 'Did you reach your origin?',
    success: 'Reach origin submitted successfully'
  },
  loading: {
    message: 'Did the loading complete?',
    success: 'Loading successfully registered'
  },
  received: {
    message: 'Did the receiving complete?',
    success: 'Receiving successfully registered'
  },
  reachDestination: {
    message: 'Did you reach your {destination}?',
    success: 'Reach {destination} submitted successfully'
  },
  discharge: {
    message: 'Is the discharge finished?',
    success: 'Discharge successfully registered'
  },
  delivered: {
    message: 'Is the delivery finished',
    success: 'Delivery successfully registered'
  },
  skip: {
    message: 'Are you sure about this action?',
    success: 'The delivery of the package was unsuccessful.'
  },
  passwordChangedSuccessfully: 'Password changed successfully',
  passwordCreatedSuccessfully: 'Password created successfully',
  unavailableDescription: "You are in 'unavailable' state!",
  deliveryCodeSentSuccessfully: 'Delivery code sent successfully',
  serviceStateSetToAvailable: "Service state set to 'Available'",
  acceptConditions: 'Badpa terms and conditions accepted'
}
